import React, { FC } from "react";
import propTypes from "prop-types";
import {
    FiUser,
    FiChevronRight,
    FiHome,
    FiKey
} from 'react-icons/fi';

import { KeyAudit } from "../../../../logic/api";

import styles from "./styles";
import flex from "../../../../styles/flex";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { locationPathTextToFriendly } from "../../../../utility/utils";
import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const KeyAuditListItem: FC<{ item: KeyAudit, onClick?: () => void }> = (props) => {
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();
    const border = styles.border

    return <div style={{ ...styles.listItem, ...border }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{t("locations.keyAudit")}</span>
        </div>
        <div style={styles.listItemFlex}>
            <ListViewItemCard
                icon={<FiHome style={styles.icon} />}
                text={props.item.location.name}
                subText={locationPathTextToFriendly(props.item.location.pathText)}
            />
            <ListViewItemCard
                icon={<FiKey style={styles.icon} />}
                text={t("lists.missing&UnexpectedCount", { count: props.item.missingCount, unexpected: props.item.unexpectedCount })}
                subText={t("lists.scanCount", { count: props.item.scanCount })}
            />
            <ListViewItemCard
                icon={<FiUser style={styles.icon} />}
                text={`${props.item.createdBy.firstName} ${props.item.createdBy.lastName}`}
                subText={toFormattedDateTimeString(new Date(props.item.createDate))}
            />
            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


KeyAuditListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func
};


export default KeyAuditListItem;